<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide blue-slide"
        v-for="(item, index) in bannerList"
        :key="index"
        style="position: relative"
      >
        <img :src="item.path" alt="" />
        <div class="home_frames" v-if="cateID == 40">
          <div class="home_boxs">
            <p>模组选型计算软件</p>
            <p></p>
            <hr />
            <p>直驱在线APP，技术领先，精准快速，一键生成模组选型方案</p>
            <div class="home_icons cursor" @click="to_type">
              <p>选型计算</p>
              <p>
                <img src="../../../static/img/common/rights.png" alt="" />
              </p>
            </div>
          </div>
        </div>
        <div class="common_type" v-else>
          <div>
            <p>
              {{
                cateID == 94
                  ? "选型计算  Calculate Selection"
                  : cateID == 93
                  ? "产品中心 Product center"
                  : cateID == 41
                  ? "新闻中心 Nws center"
                  : cateID == 58
                  ? "解决方案 Solution"
                  : "关于我们  About us"
              }}
            </p>
            <p>
              <span class="cursor" @click="to_home">首页 ></span>
              <span>{{
                cateID == 94
                  ? "选型计算"
                  : cateID == 93
                  ? "产品中心"
                  : cateID == 41
                  ? "新闻中心"
                  : cateID == 58
                  ? "解决方案"
                  : "关于我们"
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper } from "@/api/api";
export default {
  name: "Swiper",
  data() {
    return {
      bannerList: [],
    };
  },
  props: {
    cateID: "", //获取轮播的id
  },
  components: {},
  mounted() {
    this.swiperList();
  },
  watch: {
    cateID() {
      this.swiperList();
    },
  },
  methods: {
    _Swiper() {
      var mySwiper = new this.Swiper(".swiper-container", {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        on: {
          init: function () {
            this.emit("slideChangeTransitionEnd"); //在初始化时触发一次slideChangeTransitionEnd事件
          },
          // slideChangeTransitionEnd: function () {
          //   this.slides.eq(this.activeIndex).find(".ani").removeClass("ani"); //动画只展示一次
          // },
        },
      });
    },
    swiperList() {
      swiper({ cate_id: this.cateID }).then(
        (res) => {
          if ((res.data.code = 1)) {
            this.bannerList = res.data.data;
            this._Swiper();
          }
        },
        (err) => {}
      );
    },
    to_type() {
      this.$router.push({ name: "LectoType" });
    },
    //跳转首页
    to_home() {
      this.$router.push({ name: "first" });
    },
  },
  computed: {},
};
</script>

<style lang='scss' scoped>
@import "../../../static/css/common.scss";
.swiper-container {
  min-width: 1200px;
  width: 100%;
  // height: 100%;
}
.swiper-wrapper {
  height: auto;
}
.swiper-slide {
  height: 100%;
  & > img {
    width: 100%;
    height: 100%;
  }
}
.common_type {
  width: 1200px;
  margin: 0 auto;
  position: absolute;
  bottom: 50px;
  left: 50%;
  margin-left: -600px;

  & > div {
    top: 30px;
    left: 50%;
    z-index: 9999;
    p:nth-of-type(1) {
      font-size: 36px;
      color: white;
      margin-bottom: 17px;
    }
    p:nth-of-type(2) {
      font-size: 14px;
      span:nth-of-type(1) {
        color: white;
      }
      span:nth-of-type(2) {
        color: $blue;
      }
    }
  }
}
.home_frames {
  width: 1200px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
  .home_boxs {
    width: 590px;
    height: 280px;
    background: rgba(255, 255, 255, 0.8);
    position: absolute;
    left: 0px;
    top: 50%;
    margin-top: -140px;
    box-sizing: border-box;
    padding: 45px 0px 45px 60px;
    & > p:nth-of-type(1) {
      font-size: 30px;
      color: $blue;
      margin-bottom: 20px;
    }
    & > p:nth-of-type(2) {
      font-size: 20px;
      color: #333333;
      margin-bottom: 20px;
    }
    & > p:nth-of-type(3) {
      font-size: 16px;
      color: #333333;
    }
    hr {
      width: 115px;
      height: 5px;
      background: #2ab7fe;
      border: none;
      border-radius: 2px;
      margin-bottom: 25px;
    }
    .home_icons {
      width: 190px;
      height: 50px;
      background: #2ab7fe;
      margin-top: 50px;
      p {
        display: inline-block;
      }
      p:nth-of-type(1) {
        width: 145px;
        height: 50px;
        line-height: 50px;
        float: left;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
      }
      p:nth-of-type(2) {
        width: 45px;
        height: 50px;
        line-height: 50px;
        background: #0061ae;
        float: right;
        text-align: center;
        img {
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
      }
    }
  }
}
// @media screen and (max-width: 1500px) {
//   .home_frames .home_boxs {
//     width: 620px;
//     height: 280px;
//     background: #fbfbfb;
//     position: absolute;
//     left: 0px;
//     bottom: 30px;
//     box-sizing: border-box;
//     padding: 45px 60px;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/components/Module1/Swiper.vue